module.exports = __webpack_public_path__ + "static/media/Endosee-Advance-HCP-Brochure-125x155@3x.cd2aee9b.jpg";